import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const NoteCards = () => {

  const  servicesFaqData = [
    { 
        question: "What are note cards, and where can they be used?  ", 
        answer: "Note cards are printed stationery items for personal communication, corporate branding, or event invitations. They are versatile and can be used to write personalised messages, send thank-you, or convey important information. Note cards are often used professionally for client communication or branding efforts. They are also popular for personal stationery or as inserts in gift packages. With customisation options, note cards serve both functional and aesthetic purposes."
    },
    { 
        question: "What are the benefits of personalised note card printing?  ", 
        answer: "Personalised note card printing allows you to create unique designs that reflect your brand or style. Customised note cards add a personal touch to communication, making them more meaningful and impactful. They also offer flexibility in design, allowing you to include logos, monograms, or specific messaging. High-quality materials and printing ensure that the cards look professional and are durable for long-term use. Personalised note cards enhance personal and professional interactions by leaving a lasting impression."
    },
    { 
        question: "Can Printingy handle bulk orders for note card printing?   ", 
        answer: "Printingy specialises in bulk note card printing, offering cost-effective solutions for large-scale orders. Bulk printing is ideal for businesses, organisations, or individuals needing multiple cards for events, branding, or stationery. Advanced technology ensures consistent quality across all prints, regardless of order size. With quick turnaround times, we ensure that your bulk orders are completed efficiently and delivered on schedule. Whether for corporate use or personal gifting, Printingy provides reliable bulk printing services."
    },
    { 
        question: "What materials are used for premium notecard printing? ", 
        answer: "Our premium notecard printing services use high-quality materials such as textured cardstock, linen paper, and eco-friendly options. Textured cardstock provides a classic and elegant feel, suitable for formal communication. Linen paper adds a sophisticated texture, making it perfect for premium branding or event stationery. For environmentally conscious clients, we offer recycled materials that maintain a high-quality appearance. These materials ensure that the note cards are durable, visually appealing, and aligned with your personal or professional preferences."
    },
    { 
        question: "What industries and individuals benefit from custom note card printing services? ", 
        answer: "Businesses, event planners, and individuals benefit significantly from custom note card printing services. Businesses use custom note cards for client communication, branding, and internal messaging. Event planners rely on them for invitations, thank-yous, and personalised stationery. Individuals use custom note cards for personal communication, gifting, and decorative purposes. Custom note cards are versatile and add a touch of professionalism or personalisation to any interaction. Note cards are a valuable and stylish communication tool for corporate use or personal projects."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing of Note Cards');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Custom Note Cards Printing Services"
  description="High-quality printing of note cards for events, personal use, and corporate branding. Bulk personalised note card printing and premium custom note card solutions."
  keywords="Printing of Note Cards,
Note Cards Printing,
Personalised Note Cards Printing,
Premium Notecards Printing,
Custom Note Cards Printing


"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Note Cards </h1>
              <h2 className="text-muted">Customised note cards for personal, corporate, and event needs    </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Note cards are versatile tools for personalised communication, corporate branding, or event invitations. Printingy specialises in Printing of Note Cards, offering high-quality Note Cards Printing tailored to meet diverse requirements.</p>
          <p>Our services include personalised note card printing, allowing you to create unique designs that reflect your personality or brand. We provide premium notecard printing with luxurious finishes and high-resolution visuals for those seeking sophistication. Our custom note card printing also ensures that every card is tailored to your specifications, whether for personal use, corporate branding, or gifting.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Note Cards Printing Solutions  </h2>
                <h3 className="large-hed">Elegant, high-quality note cards for all purposes  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Note Cards for personal and professional use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk Note Cards Printing with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored personalised note cards printing for unique messaging.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Premium custom note cards printing with durable and luxurious materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant colours and sharp details for a professional appearance.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Multiple size and material options to suit all needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for individuals, businesses, and event organisers.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/cus-fly-1.jpg" // Path relative to the public folder
                  alt="Professional printing of note cards services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Note Cards Delivered On Time   </h2>
            <h3 className="small-hed">Focus on your message while we handle your note card printing needs  </h3>
            <p>Printingy uses advanced technology and premium materials to deliver exceptional note card printing solutions. Our personalised note card printing ensures professional and memorable results, whether for corporate branding, personal stationery, or event use.
            </p>
            <p>We guarantee quality and efficiency, ensuring timely delivery for all bulk and customised orders. Partner with Printingy for elegant and reliable note card printing solutions.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default NoteCards;
